import { Card, Space, Typography } from 'antd';

const { Text } = Typography;

// Tarjeta de sección de las pantallas de detalle del admin (pedido, cliente).
export const SectionCard = ({ icon, title, extra, children }) => (
  <Card
    size="small"
    title={
      <Space size={8}>
        <span style={{ color: '#888', display: 'flex' }}>{icon}</span>
        <Text style={{ fontSize: 11, textTransform: 'uppercase', letterSpacing: '0.5px', color: '#888', fontWeight: 700 }}>{title}</Text>
      </Space>
    }
    extra={extra}
    styles={{ body: { padding: '12px 16px' } }}
  >
    {children}
  </Card>
);
